const comparison = new Map([
  ['<', '<'],
  ['<=', '≤'],
  ['>=', '≥'],
  ['>', '>'],
  ['~=', '≈'],
  ['=~', '≈']
]);

export default (value: any): string => {
  if (!comparison.has(value)) {
    throw new Error(`Unable to translate ${value} to unicode.`)
  }

  return comparison.get(value)
}
